import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import { contactMapping } from '../constants/UtilVariables';
import { trackPage } from '../../lib/analytics-helper';

function joinContactOptions(contactChannels = []) {
  if (!Array.isArray(contactChannels)) {
    return '';
  }

  const tempChannelsArr = contactChannels.map((contactType) => {
    const temp = ((contactType && contactType.type) || '').toLocaleLowerCase();

    // Mapping contact options
    return contactMapping[temp];
  });

  return tempChannelsArr.join('|');
}

function sendFPTIForFinalContactOptions(channels, topicRefId, selectedIntent, layer) {
  const parsedChannels = joinContactOptions(channels);
  if (selectedIntent) {
    return trackPage({ id: 'contactUsPage', link: `smarthelp-select-topic|search|${topicRefId}|final|${parsedChannels}` });
  }
  return trackPage({ id: 'contactUsPage', link: `smarthelp-select-topic-L${layer}|${topicRefId}|final|${parsedChannels}` });
}

function updatedFinalContactOptions({ contactChannels, topicRefId }) {
  return {
    type: types.UPDATE_FINAL_CONTACT_OPTIONS,
    payload: {
      contactChannels,
      topicRefId,
    },
  };
}

const updateFinalContactOptions = contactChannels => (
  (dispatch, getState) => {
    const topicRefId = _get(getState(), 'selectResult.topicTreeSelectResult.topicRefId', null);
    const hasFinalContactOptions = _get(getState(), 'contactChannels.hasFinalContactOptions', null);
    const layer = _get(getState(), 'topicSelect.layer', null);
    const selectedIntent = _get(getState(), 'crawlIntentTopic.selectedIntent', null); // selected crawling topic data

    if (!hasFinalContactOptions) { // sending FPTI and avoiding duplicate UI rerender to resend
      sendFPTIForFinalContactOptions(contactChannels, topicRefId, selectedIntent, layer);
    }
    dispatch(updatedFinalContactOptions({ contactChannels, topicRefId }));
  });

module.exports = {
  updateFinalContactOptions,
  sendFPTIForFinalContactOptions,
};
